import React from 'react';
import { Box, Typography, Button, Slider, FormControlLabel, Switch } from '@mui/material';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';

const VideoConverter = () => {
  return (
    <Box sx={{ padding: '40px' }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '16px',
        marginBottom: '32px'
      }}>
        <Box sx={{
          width: '56px',
          height: '56px',
          borderRadius: '12px',
          backgroundColor: '#FBE9E7',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <VideoLibraryIcon sx={{ fontSize: 32, color: '#FF5722' }} />
        </Box>
        <Typography variant="h4" sx={{ color: '#131F32', fontWeight: 600 }}>
          Video Clip Converter
        </Typography>
      </Box>

      <Box sx={{ 
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        padding: '32px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
      }}>
        <Typography variant="h6" sx={{ marginBottom: '24px', color: '#131F32' }}>
          Upload Video for Conversion
        </Typography>

        <Box sx={{ 
          border: '2px dashed #E5E9EF',
          borderRadius: '12px',
          padding: '40px',
          textAlign: 'center',
          backgroundColor: '#F8F9FA',
          marginBottom: '32px'
        }}>
          <Typography sx={{ color: '#64748B', marginBottom: '16px' }}>
            Drag and drop your video here, or click to browse
          </Typography>
          <Button 
            variant="contained"
            sx={{
              backgroundColor: '#FF5722',
              '&:hover': {
                backgroundColor: '#F4511E'
              }
            }}
          >
            Upload Video
          </Button>
        </Box>

        <Box sx={{ maxWidth: '600px' }}>
          <Typography variant="h6" sx={{ marginBottom: '16px', color: '#131F32' }}>
            Conversion Settings
          </Typography>

          <Box sx={{ marginBottom: '24px' }}>
            <Typography sx={{ color: '#64748B', marginBottom: '8px' }}>
              Clip Duration (seconds)
            </Typography>
            <Slider
              defaultValue={30}
              min={10}
              max={60}
              valueLabelDisplay="auto"
              sx={{
                color: '#FF5722',
                '& .MuiSlider-thumb': {
                  '&:hover, &.Mui-focusVisible': {
                    boxShadow: '0 0 0 8px rgba(255, 87, 34, 0.16)'
                  }
                }
              }}
            />
          </Box>

          <Box sx={{ marginBottom: '24px' }}>
            <FormControlLabel
              control={
                <Switch 
                  sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: '#FF5722',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 87, 34, 0.08)'
                      }
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: '#FF5722'
                    }
                  }}
                />
              }
              label="Auto-detect highlights"
            />
          </Box>

          <Button 
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: '#FF5722',
              padding: '12px',
              '&:hover': {
                backgroundColor: '#F4511E'
              }
            }}
          >
            Start Conversion
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default VideoConverter; 